export default {
  iybtm: {
    host: 'https://api.iyb.tm',
  },
  lite: {
    host: 'https://lite.iyunbao.com',
  },
  iybapi: {
    host: 'https://api.iyunbao.com',
  },
  gwiyb: {
    host: 'https://gw.iyb.tm',
  },
  api: {
    host: 'https://api.baoinsurance.com',
  },
  fs: {
    host: 'https://fs.iyb.tm',
  },
};
